/* @ts-self-types="./client_wasm.d.ts" */

/**
 * A round simulated entirely in the browser (offline prototype, M1).
 */
export class LocalGame {
    static __wrap(ptr) {
        const obj = Object.create(LocalGame.prototype);
        obj.__wbg_ptr = ptr;
        LocalGameFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LocalGameFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_localgame_free(ptr, 0);
    }
    /**
     * Path of a shot of tank `tank` while it has aim help (see [`aim_path`]), else empty.
     * @param {number} tank
     * @returns {Float32Array}
     */
    aim_path(tank) {
        const ret = wasm.localgame_aim_path(this.__wbg_ptr, tank);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Tanks still in the round: the living and zombies about to rise.
     * @returns {number}
     */
    alive_count() {
        const ret = wasm.localgame_alive_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Standing barriers, layout as [`LocalGame::walls`].
     * @returns {Float32Array}
     */
    barriers() {
        const ret = wasm.localgame_barriers(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Explosions of the last moments, layout as [`NetClient::blasts`].
     * @returns {Float32Array}
     */
    blasts() {
        const ret = wasm.localgame_blasts(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    bullets() {
        const ret = wasm.localgame_bullets(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Whole seconds of the start countdown left, 0 when shooting is allowed.
     * @returns {number}
     */
    countdown() {
        const ret = wasm.localgame_countdown(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Gives tank `tank` underdog bonus `bonus` (`Bonus::to_u8`) now.
     * @param {number} tank
     * @param {number} bonus
     */
    debug_bonus(tank, bonus) {
        wasm.localgame_debug_bonus(this.__wbg_ptr, tank, bonus);
    }
    /**
     * Lays power-up `kind` two tank lengths in front of tank `tank`.
     * @param {number} tank
     * @param {number} kind
     */
    debug_drop(tank, kind) {
        wasm.localgame_debug_drop(this.__wbg_ptr, tank, kind);
    }
    /**
     * Puts power-up `kind` (wire order) into tank `tank`'s hand.
     * @param {number} tank
     * @param {number} kind
     */
    debug_give(tank, kind) {
        wasm.localgame_debug_give(this.__wbg_ptr, tank, kind);
    }
    /**
     * Tank `tank` cannot die (on) or can again.
     * @param {number} tank
     * @param {boolean} on
     */
    debug_god(tank, on) {
        wasm.localgame_debug_god(this.__wbg_ptr, tank, on);
    }
    /**
     * @param {number} tank
     */
    debug_heal(tank) {
        wasm.localgame_debug_heal(this.__wbg_ptr, tank);
    }
    /**
     * @param {number} tank
     * @returns {boolean}
     */
    debug_is_god(tank) {
        const ret = wasm.localgame_debug_is_god(this.__wbg_ptr, tank);
        return ret !== 0;
    }
    /**
     * @param {number} tank
     */
    debug_kill(tank) {
        wasm.localgame_debug_kill(this.__wbg_ptr, tank);
    }
    /**
     * Swaps tank `tank`'s components (4 bytes as `Loadout::to_bytes`), health refilled.
     * @param {number} tank
     * @param {Uint8Array} parts
     */
    debug_parts(tank, parts) {
        const ptr0 = passArray8ToWasm0(parts, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.localgame_debug_parts(this.__wbg_ptr, tank, ptr0, len0);
    }
    debug_skip_countdown() {
        wasm.localgame_debug_skip_countdown(this.__wbg_ptr);
    }
    /**
     * The zone: 0 off, 1 shrinking from now on.
     * @param {number} mode
     */
    debug_zone(mode) {
        wasm.localgame_debug_zone(this.__wbg_ptr, mode);
    }
    /**
     * Fog banks where they are now, layout as [`LocalGame::walls`].
     * @returns {Float32Array}
     */
    fog_banks() {
        const ret = wasm.localgame_fog_banks(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Holes in the ice: x, y per hole.
     * @returns {Float32Array}
     */
    holes() {
        const ret = wasm.localgame_holes(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * All mines (both players see the screen).
     * @returns {Float32Array}
     */
    mines() {
        const ret = wasm.localgame_mines(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * `parts`: 4 bytes per tank as [`Loadout::to_bytes`]; missing tanks stay standard.
     * @param {number} seed
     * @param {number} players
     * @param {Uint8Array} parts
     */
    constructor(seed, players, parts) {
        const ptr0 = passArray8ToWasm0(parts, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.localgame_new(seed, players, ptr0, len0);
        this.__wbg_ptr = ret;
        LocalGameFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {Float32Array}
     */
    oil() {
        const ret = wasm.localgame_oil(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    pickups() {
        const ret = wasm.localgame_pickups(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * A standing arena of `season` (`Season::to_u8`) with all its effects, for the guide's pictures.
     * @param {number} seed
     * @param {number} players
     * @param {number} season
     * @returns {LocalGame}
     */
    static preview(seed, players, season) {
        const ret = wasm.localgame_preview(seed, players, season);
        return LocalGame.__wrap(ret);
    }
    /**
     * Whether a spring shower is falling now.
     * @returns {boolean}
     */
    raining() {
        const ret = wasm.localgame_raining(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Season of the round (`Season::to_u8`, 0 = none).
     * @returns {number}
     */
    season() {
        const ret = wasm.localgame_season(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} tank
     * @param {number} throttle
     * @param {number} turn
     * @param {boolean} fire
     * @param {boolean} item
     */
    set_input(tank, throttle, turn, fire, item) {
        wasm.localgame_set_input(this.__wbg_ptr, tank, throttle, turn, fire, item);
    }
    /**
     * Smoke clouds: x, y, share of the time left per cloud.
     * @returns {Float32Array}
     */
    smoke() {
        const ret = wasm.localgame_smoke(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    step() {
        wasm.localgame_step(this.__wbg_ptr);
    }
    /**
     * @returns {Float32Array}
     */
    tanks() {
        const ret = wasm.localgame_tanks(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Ground patches, layout see `terrain_patches`.
     * @returns {Float32Array}
     */
    terrain() {
        const ret = wasm.localgame_terrain(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Its effects (bits, `sim::terrain`).
     * @returns {number}
     */
    terrain_effects() {
        const ret = wasm.localgame_terrain_effects(this.__wbg_ptr);
        return ret;
    }
    /**
     * Solid polygons (obstacles and border): per polygon the corner count, then x, y per corner.
     * @returns {Float32Array}
     */
    walls() {
        const ret = wasm.localgame_walls(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Wind's pull now (x, y; units/s²), empty without wind.
     * @returns {Float32Array}
     */
    wind() {
        const ret = wasm.localgame_wind(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Index of the last surviving tank, or -1.
     * @returns {number}
     */
    winner() {
        const ret = wasm.localgame_winner(this.__wbg_ptr);
        return ret;
    }
    /**
     * Like `new`, but with `season` (`Season::to_u8`, 0 = none) and `effects` (bits, 0 with a
     * season = all of it, 255 = two at random) of the caller's choice (local debug).
     * @param {number} seed
     * @param {number} players
     * @param {Uint8Array} parts
     * @param {number} season
     * @param {number} effects
     * @returns {LocalGame}
     */
    static with_season(seed, players, parts, season, effects) {
        const ptr0 = passArray8ToWasm0(parts, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.localgame_with_season(seed, players, ptr0, len0, season, effects);
        return LocalGame.__wrap(ret);
    }
    /**
     * @returns {number}
     */
    world_height() {
        const ret = wasm.localgame_world_height(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    world_width() {
        const ret = wasm.localgame_world_width(this.__wbg_ptr);
        return ret;
    }
    /**
     * Safe zone rectangle (see [`zone_rect`]).
     * @returns {Float32Array}
     */
    zone() {
        const ret = wasm.localgame_zone(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) LocalGame.prototype[Symbol.dispose] = LocalGame.prototype.free;

export class NetClient {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NetClientFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_netclient_free(ptr, 0);
    }
    /**
     * Path of the own next shot while aim help is on, from the predicted tank; else empty.
     * @param {number} alpha
     * @returns {Float32Array}
     */
    aim_path(alpha) {
        const ret = wasm.netclient_aim_path(this.__wbg_ptr, alpha);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Grey tanks without names (Design §9.3).
     * @returns {boolean}
     */
    anonymous_setting() {
        const ret = wasm.netclient_anonymous_setting(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Standing barriers (newest snapshot), layout as [`NetClient::walls`].
     * @returns {Float32Array}
     */
    barriers() {
        const ret = wasm.netclient_barriers(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Explosions of the last moments, aligned with the bullets (newest snapshot).
     * @param {number} now_ms
     * @returns {Float32Array}
     */
    blasts(now_ms) {
        const ret = wasm.netclient_blasts(this.__wbg_ptr, now_ms);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Own underdog bonus for the next round (`sim::underdog::Bonus::to_u8`, 0 = none).
     * @returns {number}
     */
    bonus() {
        const ret = wasm.netclient_bonus(this.__wbg_ptr);
        return ret;
    }
    /**
     * Their level: 0 easy, 1 medium, 2 hard.
     * @returns {number}
     */
    bot_level_setting() {
        const ret = wasm.netclient_bot_level_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * Server bots in the lobby (Design §9.3).
     * @returns {number}
     */
    bots_setting() {
        const ret = wasm.netclient_bots_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * Tank with the bounty on it this round, -1 if none.
     * @returns {number}
     */
    bounty() {
        const ret = wasm.netclient_bounty(this.__wbg_ptr);
        return ret;
    }
    /**
     * Per tank bounty points in the last finished round.
     * @returns {Uint8Array}
     */
    bounty_points() {
        const ret = wasm.netclient_bounty_points(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Bullets from the newest snapshot, extrapolated to now with wall bounces.
     * @param {number} now_ms
     * @returns {Float32Array}
     */
    bullets(now_ms) {
        const ret = wasm.netclient_bullets(this.__wbg_ptr, now_ms);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Components per slot (cannon, armor, drive, ammo).
     * @returns {Uint8Array}
     */
    component_counts() {
        const ret = wasm.netclient_component_counts(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Whole seconds of the start countdown left, 0 when shooting is allowed.
     * @param {number} now_ms
     * @returns {number}
     */
    countdown(now_ms) {
        const ret = wasm.netclient_countdown(this.__wbg_ptr, now_ms);
        return ret >>> 0;
    }
    /**
     * Asks for the emote on key `key` (0..4) over the own tank (the server checks and sends it
     * to everyone).
     * @param {number} key
     * @returns {Uint8Array}
     */
    emote(key) {
        const ret = wasm.netclient_emote(this.__wbg_ptr, key);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Emotes to show at `now_ms`: tank, emote id, share of its time gone (0..1).
     * @param {number} now_ms
     * @returns {Float32Array}
     */
    emotes(now_ms) {
        const ret = wasm.netclient_emotes(this.__wbg_ptr, now_ms);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Fog banks where they are now, layout as [`NetClient::walls`].
     * @param {number} now_ms
     * @returns {Float32Array}
     */
    fog_banks(now_ms) {
        const ret = wasm.netclient_fog_banks(this.__wbg_ptr, now_ms);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Fog of war: 0 off, 1 obstacles cast shadows, 2 also a view cone (Design §9.2).
     * @returns {number}
     */
    fog_setting() {
        const ret = wasm.netclient_fog_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * The finished round stands still on the server (round result, shop, match result).
     * @returns {boolean}
     */
    frozen() {
        const ret = wasm.netclient_frozen(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * The ghost of the first one out (newest snapshot): x, y, angle, kind of its piece
     * (`terrain_patches` numbering), may place there (0/1), share of its time left, tank, then
     * the piece as it would lie (corner count, x, y per corner); empty: none.
     * @returns {Float32Array}
     */
    ghost() {
        const ret = wasm.netclient_ghost(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    guests_setting() {
        const ret = wasm.netclient_guests_setting(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    has_round() {
        const ret = wasm.netclient_has_round(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * First message. `lobby` empty creates a new lobby; `token` identifies this browser,
     * `session` (empty for guests) the account.
     * @param {string} lobby
     * @param {Uint8Array} token
     * @param {string} session
     * @returns {Uint8Array}
     */
    hello(lobby, token, session) {
        const ptr0 = passStringToWasm0(lobby, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray8ToWasm0(token, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(session, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.netclient_hello(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        var v4 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v4;
    }
    /**
     * Holes in the ice (newest snapshot): x, y per hole.
     * @returns {Float32Array}
     */
    holes() {
        const ret = wasm.netclient_holes(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Member id of the host, 0 before the first lobby state.
     * @returns {number}
     */
    host() {
        const ret = wasm.netclient_host(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Records the input for this client tick, predicts the own tank and returns the message to send.
     * `item` is the power-up key.
     * @param {number} throttle
     * @param {number} turn
     * @param {boolean} fire
     * @param {boolean} item
     * @returns {Uint8Array}
     */
    input(throttle, turn, fire, item) {
        const ret = wasm.netclient_input(this.__wbg_ptr, throttle, turn, fire, item);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    is_host() {
        const ret = wasm.netclient_is_host(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    is_public() {
        const ret = wasm.netclient_is_public(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * This player is an admin or moderator: may kick too.
     * @returns {boolean}
     */
    is_staff() {
        const ret = wasm.netclient_is_staff(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Host: removes a member.
     * @param {number} id
     * @returns {Uint8Array}
     */
    kick(id) {
        const ret = wasm.netclient_kick(this.__wbg_ptr, id);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Who killed the own tank this round: tank index (itself if by its own shot), −1 = nobody.
     * @returns {number}
     */
    killer() {
        const ret = wasm.netclient_killer(this.__wbg_ptr);
        return ret;
    }
    /**
     * Per tank kill points in the last finished round (self kills −1).
     * @returns {Int8Array}
     */
    kills() {
        const ret = wasm.netclient_kills(this.__wbg_ptr);
        var v1 = getArrayI8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * The tank the own one killed last this round, −1 = none yet.
     * @returns {number}
     */
    last_victim() {
        const ret = wasm.netclient_last_victim(this.__wbg_ptr);
        return ret;
    }
    /**
     * Components of tank `tank` (cannon, armor, drive, ammo), see `sim::Loadout::to_bytes`.
     * @param {number} tank
     * @returns {Uint8Array}
     */
    loadout(tank) {
        const ret = wasm.netclient_loadout(this.__wbg_ptr, tank);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Components of every tank, 4 bytes each as in [`Self::loadout`], to draw them on the tanks.
     * @returns {Uint8Array}
     */
    loadouts() {
        const ret = wasm.netclient_loadouts(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {string}
     */
    lobby_code() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.netclient_lobby_code(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Cosmetics, 7 item ids per tank (paint, bullet, destruction, tracks, muzzle flash, victory
     * pose, colour; 0 = standard), see `protocol::Looks`.
     * @returns {Uint16Array}
     */
    looks() {
        const ret = wasm.netclient_looks(this.__wbg_ptr);
        var v1 = getArrayU16FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * Reward points per tank for the daily challenge done in the finished match.
     * @returns {Uint16Array}
     */
    match_challenge() {
        const ret = wasm.netclient_match_challenge(this.__wbg_ptr);
        var v1 = getArrayU16FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    match_over() {
        const ret = wasm.netclient_match_over(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Final place per tank of the finished match, 1 = winner; ties beyond the place and
     * kill points share it.
     * @returns {Uint8Array}
     */
    match_ranks() {
        const ret = wasm.netclient_match_ranks(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Reward points per tank of the finished match (only accounts keep them).
     * @returns {Uint16Array}
     */
    match_rewards() {
        const ret = wasm.netclient_match_rewards(this.__wbg_ptr);
        var v1 = getArrayU16FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * Team match: round wins it goes to (it ends at the latest after `round_count`), 0 without teams.
     * @returns {number}
     */
    match_wins() {
        const ret = wasm.netclient_match_wins(this.__wbg_ptr);
        return ret;
    }
    /**
     * Bots the host may choose (more for admins and moderators).
     * @returns {number}
     */
    max_bots() {
        const ret = wasm.netclient_max_bots(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    max_players() {
        const ret = wasm.netclient_max_players(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} i
     * @returns {boolean}
     */
    member_bot(i) {
        const ret = wasm.netclient_member_bot(this.__wbg_ptr, i);
        return ret !== 0;
    }
    /**
     * @param {number} i
     * @returns {number}
     */
    member_color(i) {
        const ret = wasm.netclient_member_color(this.__wbg_ptr, i);
        return ret;
    }
    /**
     * @param {number} i
     * @returns {boolean}
     */
    member_connected(i) {
        const ret = wasm.netclient_member_connected(this.__wbg_ptr, i);
        return ret !== 0;
    }
    /**
     * Members in join order.
     * @returns {number}
     */
    member_count() {
        const ret = wasm.netclient_member_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} i
     * @returns {boolean}
     */
    member_guest(i) {
        const ret = wasm.netclient_member_guest(this.__wbg_ptr, i);
        return ret !== 0;
    }
    /**
     * @param {number} i
     * @returns {number}
     */
    member_id(i) {
        const ret = wasm.netclient_member_id(this.__wbg_ptr, i);
        return ret >>> 0;
    }
    /**
     * @param {number} i
     * @returns {string}
     */
    member_name(i) {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.netclient_member_name(this.__wbg_ptr, i);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Colour look of member `i` (`Looks` kind 6, 0 = none).
     * @param {number} i
     * @returns {number}
     */
    member_paint(i) {
        const ret = wasm.netclient_member_paint(this.__wbg_ptr, i);
        return ret;
    }
    /**
     * Tank index, or -1 for spectators.
     * @param {number} i
     * @returns {number}
     */
    member_slot(i) {
        const ret = wasm.netclient_member_slot(this.__wbg_ptr, i);
        return ret;
    }
    /**
     * @param {number} i
     * @returns {number}
     */
    member_team(i) {
        const ret = wasm.netclient_member_team(this.__wbg_ptr, i);
        return ret;
    }
    /**
     * Own and teammates' mines; all with radar and for spectators (Design §8: hidden from
     * enemies).
     * @returns {Float32Array}
     */
    mines() {
        const ret = wasm.netclient_mines(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    constructor() {
        const ret = wasm.netclient_new();
        this.__wbg_ptr = ret;
        NetClientFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {Float32Array}
     */
    oil() {
        const ret = wasm.netclient_oil(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {Uint8Array} bytes
     * @param {number} now_ms
     * @returns {NetEvent}
     */
    on_message(bytes, now_ms) {
        const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.netclient_on_message(this.__wbg_ptr, ptr0, len0, now_ms);
        return ret;
    }
    /**
     * Power-ups on the map (newest snapshot).
     * @returns {Float32Array}
     */
    pickups() {
        const ret = wasm.netclient_pickups(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {number} now_ms
     * @returns {Uint8Array}
     */
    ping(now_ms) {
        const ret = wasm.netclient_ping(this.__wbg_ptr, now_ms);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Per tank place points in the last finished round.
     * @returns {Uint8Array}
     */
    place_points() {
        const ret = wasm.netclient_place_points(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Per tank place in the last finished round (1 = best).
     * @returns {Uint8Array}
     */
    places() {
        const ret = wasm.netclient_places(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {number}
     */
    player() {
        const ret = wasm.netclient_player(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * A match is running (no settings, start or seat changes until it ends).
     * @returns {boolean}
     */
    playing() {
        const ret = wasm.netclient_playing(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */
    powerups_setting() {
        const ret = wasm.netclient_powerups_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * Whether a spring shower is falling now.
     * @param {number} now_ms
     * @returns {boolean}
     */
    raining(now_ms) {
        const ret = wasm.netclient_raining(this.__wbg_ptr, now_ms);
        return ret !== 0;
    }
    /**
     * In the shop: done, nothing changed.
     * @returns {Uint8Array}
     */
    ready() {
        const ret = wasm.netclient_ready(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Per tank: done shopping (1) or not (0).
     * @returns {Uint8Array}
     */
    ready_flags() {
        const ret = wasm.netclient_ready_flags(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * In the shop: done with these components per slot (see `sim::Loadout`); the server
     * charges every changed slot.
     * @param {Uint8Array} loadout
     * @returns {Uint8Array}
     */
    ready_with(loadout) {
        const ptr0 = passArray8ToWasm0(loadout, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.netclient_ready_with(this.__wbg_ptr, ptr0, len0);
        var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v2;
    }
    /**
     * Why the server closed the connection: version, not_found, lobby_full, server_full,
     * kicked, replaced, no_guests ("" if it did not).
     * @returns {string}
     */
    rejected_reason() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.netclient_rejected_reason(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    round_count() {
        const ret = wasm.netclient_round_count(this.__wbg_ptr);
        return ret;
    }
    /**
     * Round within the match, 0 during warm-up.
     * @returns {number}
     */
    round_number() {
        const ret = wasm.netclient_round_number(this.__wbg_ptr);
        return ret;
    }
    /**
     * Round count setting, 0 = automatic.
     * @returns {number}
     */
    rounds_setting() {
        const ret = wasm.netclient_rounds_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    rtt() {
        const ret = wasm.netclient_rtt(this.__wbg_ptr);
        return ret;
    }
    /**
     * Season of the round (`Season::to_u8`, 0 = none).
     * @returns {number}
     */
    season() {
        const ret = wasm.netclient_season(this.__wbg_ptr);
        return ret;
    }
    /**
     * Seasons: 0 off, 1 random each round, 2 in turn (Design §4.1).
     * @returns {number}
     */
    seasons_setting() {
        const ret = wasm.netclient_seasons_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * Host: new lobby settings (`rounds` 0 = automatic).
     * @param {number} max_players
     * @param {boolean} _public
     * @param {number} rounds
     * @param {number} powerups
     * @param {boolean} guests
     * @param {boolean} anonymous
     * @param {number} bots
     * @param {number} bot_level
     * @param {number} fog
     * @param {number} seasons
     * @param {number} terrain
     * @param {number} teams
     * @param {number} wins
     * @returns {Uint8Array}
     */
    settings(max_players, _public, rounds, powerups, guests, anonymous, bots, bot_level, fog, seasons, terrain, teams, wins) {
        const ret = wasm.netclient_settings(this.__wbg_ptr, max_players, _public, rounds, powerups, guests, anonymous, bots, bot_level, fog, seasons, terrain, teams, wins);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * The daily challenge in the open shop: weapon slot and part, target slot and part (all 0:
     * none known, or done already).
     * @returns {Uint8Array}
     */
    shop_challenge() {
        const ret = wasm.netclient_shop_challenge(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Whole seconds until the shop closes.
     * @param {number} now_ms
     * @returns {number}
     */
    shop_seconds(now_ms) {
        const ret = wasm.netclient_shop_seconds(this.__wbg_ptr, now_ms);
        return ret >>> 0;
    }
    /**
     * Smoke clouds (newest snapshot): x, y, share of the time left per cloud.
     * @returns {Float32Array}
     */
    smoke() {
        const ret = wasm.netclient_smoke(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Between matches: watch (`true`) or play.
     * @param {boolean} watch
     * @returns {Uint8Array}
     */
    spectate(watch) {
        const ret = wasm.netclient_spectate(this.__wbg_ptr, watch);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Per tank match points spent in the shop this match, as of the last finished round.
     * @returns {Int16Array}
     */
    spent() {
        const ret = wasm.netclient_spent(this.__wbg_ptr);
        var v1 = getArrayI16FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * Host: deals the players out anew; 0 shuffle, 1 people against bots, 2 balance by rating.
     * @param {number} how
     * @returns {Uint8Array}
     */
    split(how) {
        const ret = wasm.netclient_split(this.__wbg_ptr, how);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Host: starts the match.
     * @returns {Uint8Array}
     */
    start() {
        const ret = wasm.netclient_start(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Whole seconds until the host may start the next match.
     * @param {number} now_ms
     * @returns {number}
     */
    start_wait_secs(now_ms) {
        const ret = wasm.netclient_start_wait_secs(this.__wbg_ptr, now_ms);
        return ret >>> 0;
    }
    /**
     * Match points for `changed` more swaps of your own (by the tanks in the match and your
     * swaps so far).
     * @param {number} changed
     * @returns {number}
     */
    swap_cost(changed) {
        const ret = wasm.netclient_swap_cost(this.__wbg_ptr, changed);
        return ret;
    }
    /**
     * Tanks that did the daily challenge since the last call.
     * @returns {Uint8Array}
     */
    take_challenges() {
        const ret = wasm.netclient_take_challenges(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Points earned or lost since the last call, 4 numbers each: tank, points, why (0 kill,
     * 1 bounty, 2 itself or a teammate killed), the tank killed (-1 none).
     * @returns {Int32Array}
     */
    take_gains() {
        const ret = wasm.netclient_take_gains(this.__wbg_ptr);
        var v1 = getArrayI32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Player colour per tank index (the tank index if unknown).
     * @returns {Uint8Array}
     */
    tank_colors() {
        const ret = wasm.netclient_tank_colors(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Player name per tank index ("" if unknown); known from the round start on, before any snapshot.
     * @returns {string[]}
     */
    tank_names() {
        const ret = wasm.netclient_tank_names(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]);
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Rank badge per tank (`Member::rank`), 0 if unknown.
     * @returns {Uint8Array}
     */
    tank_ranks() {
        const ret = wasm.netclient_tank_ranks(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Team per tank index; empty with teams off.
     * @returns {Uint8Array}
     */
    tank_teams() {
        const ret = wasm.netclient_tank_teams(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Tanks for rendering (layout as `LocalGame::tanks`). `alpha` blends the own
     * predicted tank between its last two client ticks.
     * @param {number} now_ms
     * @param {number} alpha
     * @returns {Float32Array}
     */
    tanks(now_ms, alpha) {
        const ret = wasm.netclient_tanks(this.__wbg_ptr, now_ms, alpha);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Between matches with teams on: member `id` joins `team` (others: host only).
     * @param {number} id
     * @param {number} team
     * @returns {Uint8Array}
     */
    team(id, team) {
        const ret = wasm.netclient_team(this.__wbg_ptr, id, team);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Rounds won per team this match (empty without teams).
     * @returns {Uint8Array}
     */
    team_wins() {
        const ret = wasm.netclient_team_wins(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Teams: 0 off, else how many (Design §12).
     * @returns {number}
     */
    teams_setting() {
        const ret = wasm.netclient_teams_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * Its effects (bits, `sim::terrain`).
     * @returns {number}
     */
    terrain_effects() {
        const ret = wasm.netclient_terrain_effects(this.__wbg_ptr);
        return ret;
    }
    /**
     * Ground patches, layout as `LocalGame::terrain`.
     * @returns {Float32Array}
     */
    terrain_patches() {
        const ret = wasm.netclient_terrain_patches(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Terrain effects per round: 0 all, else that many.
     * @returns {number}
     */
    terrain_setting() {
        const ret = wasm.netclient_terrain_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * Changes with the ground a ghost placed: the renderer fetches `terrain_patches` again.
     * @returns {number}
     */
    terrain_stamp() {
        const ret = wasm.netclient_terrain_stamp(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Per tank match points so far.
     * @returns {Int16Array}
     */
    totals() {
        const ret = wasm.netclient_totals(this.__wbg_ptr);
        var v1 = getArrayI16FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    walls() {
        const ret = wasm.netclient_walls(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Wind's pull now (x, y; units/s²), empty without wind.
     * @param {number} now_ms
     * @returns {Float32Array}
     */
    wind(now_ms) {
        const ret = wasm.netclient_wind(this.__wbg_ptr, now_ms);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Winner of the finished round (place 1), or -1.
     * @returns {number}
     */
    winner() {
        const ret = wasm.netclient_winner(this.__wbg_ptr);
        return ret;
    }
    /**
     * Round wins a team match goes to, 0 = automatic (Design §12).
     * @returns {number}
     */
    wins_setting() {
        const ret = wasm.netclient_wins_setting(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    world_height() {
        const ret = wasm.netclient_world_height(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    world_width() {
        const ret = wasm.netclient_world_width(this.__wbg_ptr);
        return ret;
    }
    /**
     * Own tank index, or -1 while spectating.
     * @returns {number}
     */
    you() {
        const ret = wasm.netclient_you(this.__wbg_ptr);
        return ret;
    }
    /**
     * Safe zone [min x, min y, max x, max y] now; empty without zone.
     * @param {number} now_ms
     * @returns {Float32Array}
     */
    zone(now_ms) {
        const ret = wasm.netclient_zone(this.__wbg_ptr, now_ms);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) NetClient.prototype[Symbol.dispose] = NetClient.prototype.free;

/**
 * Return values of [`NetClient::on_message`].
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}
 */
export const NetEvent = Object.freeze({
    None: 0, "0": "None",
    Welcome: 1, "1": "Welcome",
    Round: 2, "2": "Round",
    RoundOver: 3, "3": "RoundOver",
    Rejected: 4, "4": "Rejected",
    Lobby: 5, "5": "Lobby",
    MatchOver: 6, "6": "MatchOver",
    Shop: 7, "7": "Shop",
    Standings: 8, "8": "Standings",
    Emote: 9, "9": "Emote",
    Challenge: 10, "10": "Challenge",
});

/**
 * Fixed constants the renderer needs.
 * @returns {Float32Array}
 */
export function constants() {
    const ret = wasm.constants();
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Simulation version compiled into this WASM module.
 * @returns {number}
 */
export function sim_version() {
    const ret = wasm.sim_version();
    return ret >>> 0;
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_throw_41e9ee4f547fc59a: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbindgen_generic_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./client_wasm_bg.js": import0,
    };
}

const LocalGameFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_localgame_free(ptr, 1));
const NetClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_netclient_free(ptr, 1));

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayI16FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt16ArrayMemory0().subarray(ptr / 2, ptr / 2 + len);
}

function getArrayI32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayI8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU16FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint16ArrayMemory0().subarray(ptr / 2, ptr / 2 + len);
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let cachedFloat32ArrayMemory0 = null;
function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

let cachedInt16ArrayMemory0 = null;
function getInt16ArrayMemory0() {
    if (cachedInt16ArrayMemory0 === null || cachedInt16ArrayMemory0.byteLength === 0) {
        cachedInt16ArrayMemory0 = new Int16Array(wasm.memory.buffer);
    }
    return cachedInt16ArrayMemory0;
}

let cachedInt32ArrayMemory0 = null;
function getInt32ArrayMemory0() {
    if (cachedInt32ArrayMemory0 === null || cachedInt32ArrayMemory0.byteLength === 0) {
        cachedInt32ArrayMemory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32ArrayMemory0;
}

let cachedInt8ArrayMemory0 = null;
function getInt8ArrayMemory0() {
    if (cachedInt8ArrayMemory0 === null || cachedInt8ArrayMemory0.byteLength === 0) {
        cachedInt8ArrayMemory0 = new Int8Array(wasm.memory.buffer);
    }
    return cachedInt8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint16ArrayMemory0 = null;
function getUint16ArrayMemory0() {
    if (cachedUint16ArrayMemory0 === null || cachedUint16ArrayMemory0.byteLength === 0) {
        cachedUint16ArrayMemory0 = new Uint16Array(wasm.memory.buffer);
    }
    return cachedUint16ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedFloat32ArrayMemory0 = null;
    cachedInt16ArrayMemory0 = null;
    cachedInt32ArrayMemory0 = null;
    cachedInt8ArrayMemory0 = null;
    cachedUint16ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (!module.ok) {
            throw new Error(`failed to fetch Wasm: ${module.status} ${module.statusText} fetching '${module.url}'`);
        }

        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('client_wasm_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
